module.exports = "pegasus_template/assets/background-patterns/fall-automotive-theme.jpg";